module.exports = __webpack_public_path__ + "img/psol.c6fc4c62.jpg";